import React from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import ExpandRow from '../../../../core/components/expand-row';
import RowGroup from '../row-group';
import RowSubgroup from '../row-subgroup';

import {
  Column,
  Container,
  Table,
  Title,
  Row,
  Create,
  Body,
} from './styles';

const GroupsTable = (props) => {
  const {
    handleOpenGroupModal,
    handleOpenEditModal,
    onCreateClick,
    grouped,
    handleOpenModalDelete,
  } = props;

  const zeroState = !_.isEmpty(grouped) && _.last(grouped);

  const handleEditGroup = (row) => {
    handleOpenGroupModal(row);
  };

  const handleEdit = (group, currrent) => {
    handleOpenEditModal(group, currrent);
  };

  return (
    <Container>
      <Table basic="very">
        <Body>
          <Row>
            <Column>
              <Title marginleft>
                Name
              </Title>
            </Column>
            <Column><Title>Description</Title></Column>
            <Column />
            <Column />
          </Row>

          {grouped && _.map(grouped, (row, index) => {
            const { folders } = row;

            const noBorderFirstIndex = index === 0;

            return (
              <ExpandRow
                key={row.id}
                expanded={(zeroState && grouped.length === 1 && zeroState.folders.length === 1)}
              >
                <ExpandRow.RowTitle>

                  <RowGroup
                    id={row.id}
                    noBorderFirstIndex={noBorderFirstIndex}
                    color={row.color}
                    name={row.name}
                    isUngrouped={row.isUngrouped}
                    description={row.description}
                    action={index < grouped.length - 1}
                    handleEdit={() => handleEditGroup(row)}
                    handleDelete={handleOpenModalDelete}
                  />

                </ExpandRow.RowTitle>

                <ExpandRow.RowContent>
                  {_.map(folders, (contentRow) => (
                    <RowSubgroup
                      key={contentRow.id}
                      id={contentRow.id}
                      name={contentRow.name}
                      isDefault={contentRow.isDefault}
                      action={index < grouped.length - 1}
                      handleEdit={() => handleEdit(row, contentRow)}
                      handleDelete={handleOpenModalDelete}
                      description={contentRow.description}
                    />
                  ))}

                  <Row>
                    <Column noborder>

                      <Create
                        onClick={() => onCreateClick(row)}
                      >
                        Create Folder
                      </Create>
                    </Column>
                  </Row>

                </ExpandRow.RowContent>

              </ExpandRow>

            );
          })}
        </Body>
      </Table>

    </Container>
  );
};

GroupsTable.propTypes = {
  grouped: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  handleOpenEditModal: PropTypes.func.isRequired,
  handleOpenModalDelete: PropTypes.func.isRequired,
  handleOpenGroupModal: PropTypes.func.isRequired,
  onCreateClick: PropTypes.func.isRequired,
};

export default GroupsTable;
